module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00059.159157d.png";